import type { MisconceptionDefinition } from '../types'

export const GET_NEGATIEF: MisconceptionDefinition[] = [
  {
    id: 'get.negative-subtraction-direction',
    label: 'Negatief aftrekken omgedraaid',
    module: 'Getalbegrip',
    description:
      'Leerling draait de richting om bij aftrekken met negatieve getallen.',
    typicalFamilies: ['GET-NEGATIEF-MIN'],
  },
  {
    id: 'get.negatief-houdt-negatief',
    label: 'Antwoord moet negatief blijven',
    module: 'Getalbegrip',
    description:
      'Leerling denkt dat als er een negatief getal in de som staat, het antwoord ook negatief moet zijn (−3 + 7 → −10 of −4).',
    typicalFamilies: ['GET-NEGATIEF-PLUS', 'GET-NEGATIEF'],
  },
  {
    id: 'get.beide-negatief',
    label: 'Beide getallen als negatief behandeld',
    module: 'Getalbegrip',
    description:
      'Leerling behandelt beide getallen als negatief (−3 + 7 → −3 + −7).',
    typicalFamilies: ['GET-NEGATIEF-PLUS', 'GET-NEGATIEF'],
  },
  {
    id: 'get.negatief-plus-negatief-aftrekken',
    label: '+ (−a) als − (−a) gelezen',
    module: 'Getalbegrip',
    description:
      'Leerling leest + (−3) als − (−3) en draait dus het minteken om.',
    typicalFamilies: ['GET-NEGATIEF-PLUS'],
  },
  {
    id: 'get.mintekens-vallen-weg',
    label: 'Twee mintekens vallen weg-regel verkeerd toegepast',
    module: 'Getalbegrip',
    description:
      'Leerling past "min × min = plus" toe op + (−a), waardoor het minteken verdwijnt.',
    typicalFamilies: ['GET-NEGATIEF-PLUS', 'GET-NEGATIEF-MIN'],
  },
  {
    id: 'get.haakjes-negeren',
    label: 'Haakjes met minteken genegeerd',
    module: 'Getalbegrip',
    description:
      'Leerling negeert het minteken binnen haakjes (b.v. + (−3) → + 3).',
    typicalFamilies: ['GET-NEGATIEF-PLUS', 'GET-NEGATIEF-MIN'],
  },
  {
    id: 'get.absoluut-verschil-positief',
    label: 'Positief verschil als antwoord',
    module: 'Getalbegrip',
    description:
      'Leerling geeft het absolute verschil als positief antwoord, ook als het resultaat negatief moet zijn (−6 + −9 → 3).',
    typicalFamilies: ['GET-NEGATIEF-PLUS', 'GET-NEGATIEF-MIN'],
  },
  {
    id: 'get.alles-negatief',
    label: 'Alles als negatieve som',
    module: 'Getalbegrip',
    description:
      'Leerling pakt zowel het minteken als de absolute som: −(a + b) i.p.v. −a + b.',
    typicalFamilies: ['GET-NEGATIEF-PLUS'],
  },
  {
    id: 'get.saldo-positief-aanname',
    label: 'Bijstorting maakt saldo positief',
    module: 'Getalbegrip',
    description:
      'Leerling denkt dat een bijstorting het saldo altijd positief maakt, ongeacht de hoogte van het negatieve saldo.',
    typicalFamilies: ['GET-NEGATIEF-PLUS'],
  },
  {
    id: 'get.afhalen-na-bijstorten-genegeerd',
    label: 'Tweede afboeking vergeten',
    module: 'Getalbegrip',
    description:
      'Leerling vergeet een tweede afboeking in een meerstapsverhaal met saldo.',
    typicalFamilies: ['GET-NEGATIEF-PLUS'],
  },
  {
    id: 'get.bijstorten-genegeerd',
    label: 'Bijstorting vergeten',
    module: 'Getalbegrip',
    description:
      'Leerling vergeet een bijstorting in een meerstapsverhaal met saldo.',
    typicalFamilies: ['GET-NEGATIEF-PLUS'],
  },
  {
    id: 'get.negatief-min-altijd-positief',
    label: 'Aftrekken levert altijd positief antwoord',
    module: 'Getalbegrip',
    description:
      'Leerling denkt dat het resultaat van een aftrekking altijd positief is en negeert dat het antwoord onder 0 kan zakken.',
    typicalFamilies: ['GET-NEGATIEF-MIN', 'GET-NEGATIEF'],
  },
  {
    id: 'get.negatief-min-optellen-min',
    label: 'Twee minnen bij elkaar opgeteld in plaats van verdiept',
    module: 'Getalbegrip',
    description:
      'Leerling behandelt "−a − b" als optelling met verkeerd teken en komt op een verkeerde uitkomst uit.',
    typicalFamilies: ['GET-NEGATIEF-MIN', 'GET-NEGATIEF'],
  },
  {
    id: 'get.negatief-min-optellen-positief',
    label: 'Aftrekken behandeld als optellen bij negatieve getallen',
    module: 'Getalbegrip',
    description:
      'Leerling telt op in plaats van af te trekken wanneer een negatief getal in het spel is.',
    typicalFamilies: ['GET-NEGATIEF-MIN', 'GET-NEGATIEF'],
  },
  {
    id: 'get.negatief-teken-genegeerd',
    label: 'Minteken genegeerd bij negatief getal',
    module: 'Getalbegrip',
    description:
      'Leerling negeert het minteken en behandelt het negatieve getal als positief getal.',
    typicalFamilies: ['GET-NEGATIEF', 'GET-NEGATIEF-MIN', 'GET-NEGATIEF-PLUS'],
  },
  {
    id: 'get.negatief-fout-bewerking',
    label: 'Verkeerde bewerking bij negatieve getallen',
    module: 'Getalbegrip',
    description:
      'Leerling kiest de verkeerde bewerking (optellen i.p.v. aftrekken of andersom) bij negatieve getallen.',
    typicalFamilies: ['GET-NEGATIEF', 'GET-NEGATIEF-MIN'],
  },
  {
    id: 'get.negatief-tekenregel-vergeten',
    label: 'Tekenregel vergeten',
    module: 'Getalbegrip',
    description:
      'Leerling past de tekenregel niet toe bij optellen of aftrekken van negatieve getallen.',
    typicalFamilies: ['GET-NEGATIEF', 'GET-NEGATIEF-MIN'],
  },
  {
    id: 'get.negatief-grootte-omgekeerd',
    label: 'Grootte van negatieve getallen omgekeerd',
    module: 'Getalbegrip',
    description:
      'Leerling denkt dat een negatief getal met een grotere absolute waarde groter is (bv. -5 > -2).',
    typicalFamilies: ['GET-NEGATIEF'],
  },
  {
    id: 'get.negatief-gelijk-aangenomen',
    label: 'Negatieve getallen als gelijk aangenomen',
    module: 'Getalbegrip',
    description:
      'Leerling beschouwt twee negatieve getallen als gelijk, ongeacht hun absolute waarde.',
    typicalFamilies: ['GET-NEGATIEF'],
  },
  {
    id: 'get.negatief-onbeslist',
    label: 'Onbeslist bij vergelijking met negatief getal',
    module: 'Getalbegrip',
    description:
      'Leerling kan de orderelatie tussen een negatief en positief getal niet bepalen.',
    typicalFamilies: ['GET-NEGATIEF'],
  },
  {
    id: 'get.negatief-volgorde-omgedraaid',
    label: 'Volgorde van getallen omgedraaid',
    module: 'Getalbegrip',
    description:
      'Leerling draait de volgorde van negatieve getallen op de getallenlijn om.',
    typicalFamilies: ['GET-NEGATIEF'],
  },
  {
    id: 'get.negatief-teken-toegevoegd',
    label: 'Extra minteken toegevoegd',
    module: 'Getalbegrip',
    description:
      'Leerling voegt onterecht een minteken toe aan een positief getal in de uitkomst.',
    typicalFamilies: ['GET-NEGATIEF', 'GET-NEGATIEF-MIN'],
  },
  {
    id: 'get.negatief-blijft-negatief',
    label: 'Uitkomst blijft negatief aangenomen',
    module: 'Getalbegrip',
    description:
      'Leerling neemt aan dat een uitkomst met een negatief getal altijd negatief is, ongeacht de bewerking.',
    typicalFamilies: ['GET-NEGATIEF', 'GET-NEGATIEF-MIN', 'GET-MACHT-GRONDTAL'],
  },
  {
    id: 'get.negatief-min-min-verschil',
    label: 'Min-min als verschil opgevat',
    module: 'Getalbegrip',
    description: 'Leerling rekent a − (−b) als a − b in plaats van a + b.',
    typicalFamilies: ['GET-NEGATIEF-MIN'],
  },
  {
    id: 'get.negatief-min-min-wegstrepen',
    label: 'Twee minnen weggestreept',
    module: 'Getalbegrip',
    description:
      'Leerling streept de twee mintekens weg en behandelt de bewerking als gewone aftrekking.',
    typicalFamilies: ['GET-NEGATIEF-MIN'],
  },
  {
    id: 'get.negatief-min-teken-vergeten',
    label: 'Minteken vergeten in tussenstap',
    module: 'Getalbegrip',
    description:
      'Leerling vergeet het minteken in een tussenstap van de aftrekking met negatieve getallen.',
    typicalFamilies: ['GET-NEGATIEF-MIN'],
  },
  {
    id: 'get.negatief-min-min-niet-plus',
    label: 'Min-min niet als plus herkend',
    module: 'Getalbegrip',
    description: 'Leerling herkent niet dat −(−b) gelijk is aan +b.',
    typicalFamilies: ['GET-NEGATIEF-MIN'],
  },
  {
    id: 'get.negatief-min-uitkomst-altijd-negatief',
    label: 'Aftrekken levert altijd negatief op',
    module: 'Getalbegrip',
    description:
      'Leerling neemt aan dat aftrekken met negatieve getallen altijd een negatieve uitkomst geeft.',
    typicalFamilies: ['GET-NEGATIEF-MIN'],
  },
  {
    id: 'get.negatief-min-startgetal-verkeerd',
    label: 'Verkeerd startgetal gekozen',
    module: 'Getalbegrip',
    description:
      'Leerling kiest het verkeerde startgetal bij aftrekken op de getallenlijn.',
    typicalFamilies: ['GET-NEGATIEF-MIN'],
  },
]
